// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getBookingCancellationTypeById } from 'app/constants/enums/BookingCancellationType/main';

/* eslint-disable max-len */
export const ADMINISTRATIVE = getBookingCancellationTypeById('administrative');
export const STUDENT = getBookingCancellationTypeById('student');
export const TEACHER = getBookingCancellationTypeById('teacher');
/* eslint-enable max-len */
